export const components = [{
	label: '基础字段',
	value: [{
			type: 'input',
			name: '单行文本',
			icon: 'icon-input',
			options: [{
				title: '标题',
				value: '单行文本',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '宽度',
				value: '100%',
				type: 'input',
				attrName: 'width'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: 'string',
					type: 'select',
					child: [{
							label: '字符串',
							value: 'string'
						},
						{
							label: '数字',
							value: 'number'
						},
						{
							label: '布尔值',
							value: 'boolean'
						},
						{
							label: '整数',
							value: 'integer'
						},
						{
							label: '浮点数',
							value: 'float'
						},
						{
							label: 'URL地址',
							value: 'url'
						},
						{
							label: '邮箱地址',
							value: 'email'
						},
						{
							label: '十六进制',
							value: 'hex'
						}
					],
					attrName: 'dataType'
				}, {
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				}, {
					value: '',
					type: 'input',
					placeholder: '填写正则表达式',
					attrName: 'pattern'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				title: '占位内容',
				value: '',
				type: 'input',
				attrName: 'placeholder'
			}, {
				title: '最大限制长度',
				value: '50',
				type: 'input',
				attrName: 'maxlength'
			},{
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			},{
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '隐藏',
				attrName: 'hide'
			}]
		},
		{
			type: 'textarea',
			name: '多行文本',
			icon: 'icon-diy-com-textarea',
			options: [{
				title: '标题',
				value: '多行文本',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '宽度',
				value: '100%',
				type: 'input',
				attrName: 'width'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: 'string',
					type: 'select',
					child: [{
							label: '字符串',
							value: 'string'
						},
						{
							label: '数字',
							value: 'number'
						},
						{
							label: '布尔值',
							value: 'boolean'
						},
						{
							label: '整数',
							value: 'integer'
						},
						{
							label: '浮点数',
							value: 'float'
						},
						{
							label: 'URL地址',
							value: 'url'
						},
						{
							label: '邮箱地址',
							value: 'email'
						},
						{
							label: '十六进制',
							value: 'hex'
						}
					],
					attrName: 'dataType'
				}, {
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				}, {
					value: '',
					type: 'input',
					placeholder: '填写正则表达式',
					attrName: 'pattern'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				title: '占位内容',
				value: '',
				type: 'input',
				attrName: 'placeholder'
			}, {
				title: '最大限制长度',
				value: '200',
				type: 'input',
				attrName: 'maxlengthtxt'
			},{
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}]
		},
		{
			type: 'number',
			name: '计数器',
			icon: 'icon-number',
			options: [{
				title: '标题',
				value: '计数器',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '宽度',
				value: '',
				type: 'input',
				attrName: 'width'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '最大限制长度',
				value: '50',
				type: 'input',
				attrName: 'maxlength'
			},{
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}, {
				title: '最小值',
				value: '',
				type: 'inputNumber',
				attrName: 'min'
			}, {
				title: '最大值',
				value: '',
				type: 'inputNumber',
				attrName: 'max'
			}, {
				title: '步长',
				value: 1,
				type: 'inputNumber',
				attrName: 'step'
			}]
		},
		{
			type: 'radio',
			name: '单选框组',
			icon: 'icon-radio-active',
			options: [{
					title: '标题',
					value: '单选框组',
					type: 'input',
					attrName: 'formTitle'
				}, {
					title: '宽度',
					value: '',
					type: 'input',
					attrName: 'width'
				},
				{
					title: '布局方式',
					value: false,
					type: 'radioButton',
					attrName: 'inline',
					groups: [{
						label: '块级',
						value: 'false'
					}, {
						label: '行内',
						value: 'true'
					}]
				}, {
					title: '默认值',
					value: '',
					type: 'input',
					attrName: 'defaultValue'
				}, {
					title: '是否显示标签',
					value: false,
					type: 'switch',
					attrName: 'showLabel'
				}, {
					title: '选项',
					attrName: 'dynamicChange',
					list: [{
						value: false,
						type: 'radioButton',
						attrName: 'remote',
						remoteFunc: '',
						props: {
							value: 'value',
							label: 'label'
						},
						options: [{
								value: '选项1',
								label: '选项1'
							},
							{
								value: '选项2',
								label: '选项2'
							},
							{
								value: '选项3',
								label: '选项3'
							}
						]
					}]
				}, {
					title: '操作属性',
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					title: '校验',
					attrName: 'regex',
					list: [{
						value: false,
						type: 'checkbox',
						name: '必填',
						attrName: 'required'
					},{
						value: '',
						type: 'input',
						placeholder: '错误信息提示',
						attrName: 'errormsg'
					}]
				},{
					value:[],
					attrName:'remoteOptions'
				}
			]
		},
		{
			type: 'checkbox',
			name: '多选框组',
			icon: 'icon-check-box',
			options: [{
					title: '标题',
					value: '多选框组',
					type: 'input',
					attrName: 'formTitle'
				}, {
					title: '宽度',
					value: '',
					type: 'input',
					attrName: 'width'
				},
				{
					title: '布局方式',
					value: false,
					type: 'radioButton',
					attrName: 'inline',
					groups: [{
						label: '块级',
						value: 'false'
					}, {
						label: '行内',
						value: 'true'
					}]
				}, {
					value: [],
					attrName: 'defaultValue'
				}, {
					title: '是否显示标签',
					value: false,
					type: 'switch',
					attrName: 'showLabel'
				}, {
					title: '选项',
					attrName: 'dynamicChange',
					list: [{
						value: false,
						type: 'radioButton',
						attrName: 'remote',
						remoteFunc: '',
						props: {
							value: 'value',
							label: 'label'
						},
						options: [{
								value: '选项11'
							},
							{
								value: '选项22'
							},
							{
								value: '选项33'
							}
						]
					}]
				}, {
					title: '操作属性',
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					title: '校验',
					attrName: 'regex',
					list: [{
						value: false,
						type: 'checkbox',
						name: '必填',
						attrName: 'required'
					},{
						value: '',
						type: 'input',
						placeholder: '错误信息提示',
						attrName: 'errormsg'
					}]
				},{
					value:[],
					attrName:'remoteOptions'
				}
			]
		},
		{
			type: 'time',
			name: '时间选择器',
			icon: 'icon-time',
			options: [{
				title: '标题',
				value: '时间选择器',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '宽度',
				value: '',
				type: 'input',
				attrName: 'width'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultTimeValue'
			}, {
				title: '占位内容',
				value: '',
				type: 'input',
				attrName: 'placeholder'
			}, {
				title: '是否为范围选择',
				value: false,
				type: 'switch',
				attrName: 'isRange'
			}, {
				title: '格式',
				value: 'HH:mm:ss',
				type: 'input',
				attrName: 'format'
			}, {
				title: '操作属性',
				attrName: 'attr',
				list: [{
					value: false,
					type: 'checkbox',
					name: '完全只读',
					attrName: 'readonly'
				}, {
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					value: true,
					type: 'checkbox',
					name: '文本框可输入',
					attrName: 'editable'
				}, {
					value: true,
					type: 'checkbox',
					name: '显示清除按钮',
					attrName: 'clearable'
				}, {
					value: true,
					type: 'checkbox',
					name: '使用箭头进行时间选择',
					attrName: 'arrowControl'
				}]
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				title: '开始时间占位内容',
				value: '',
				type: 'input',
				attrName: 'startPlaceholder'
			}, {
				title: '结束时间占位内容',
				value: '',
				type: 'input',
				attrName: 'endPlaceholder'
			}]
		},
		{
			type: 'date',
			name: '日期选择器',
			icon: 'icon-date',
			options: [{
				title: '标题',
				value: '日期选择器',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '宽度',
				value: '',
				type: 'input',
				attrName: 'width'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '占位内容',
				value: '',
				type: 'input',
				attrName: 'placeholder'
			}, {
				value: 'date',
				type: 'select',
				child: [{
						label: 'year',
						value: 'year'
					},
					{
						label: 'month',
						value: 'month'
					},
					{
						label: 'date',
						value: 'date'
					},
					{
						label: 'dates',
						value: 'dates'
					},
					{
						label: 'datetime',
						value: 'datetime'
					},
					{
						label: 'datetimerange',
						value: 'datetimerange'
					},
					{
						label: 'daterange',
						value: 'daterange'
					}
				],
				attrName: 'type'
			}, {
				title: '是否截取时间戳',
				value: false,
				type: 'switch',
				attrName: 'timestamp'
			}, {
				title: '格式',
				value: 'yyyy-MM-dd',
				type: 'input',
				attrName: 'format'
			}, {
				title: '传参格式',
				value: 'yyyy-MM-dd HH:mm:ss',
				type: 'input',
				attrName: 'valueformat'
			},{
				title: '操作属性',
				attrName: 'attr',
				list: [{
					value: false,
					type: 'checkbox',
					name: '完全只读',
					attrName: 'readonly'
				}, {
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					value: true,
					type: 'checkbox',
					name: '文本框可输入',
					attrName: 'editable'
				}, {
					value: true,
					type: 'checkbox',
					name: '显示清除按钮',
					attrName: 'clearable'
				}]
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}]
		},
		{
			type: 'rate',
			name: '评分',
			icon: 'icon-pingfen1',
			options: [{
				title: '标题',
				value: '评分',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '默认值',
				value: null,
				type: 'input',
				attrName: 'defaultRateValue'
			}, {
				title: '最大值',
				value: 5,
				type: 'inputNumber',
				attrName: 'max'
			}, {
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				title: '允许半选',
				value: false,
				type: 'switch',
				attrName: 'allowHalf'
			}]
		},
		{
			type: 'color',
			name: '颜色选择器',
			icon: 'icon-color',
			options: [{
				title: '标题',
				value: '评分',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '支持透明度选择',
				value: false,
				type: 'switch',
				attrName: 'showAlpha'
			}, {
				title: '默认值',
				value: null,
				type: 'input',
				attrName: 'defaultColorValue'
			}, {
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}, {
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}]
		},
		{
			type: 'select',
			name: '下拉选择框',
			icon: 'icon-select',
			options: [{
					title: '标题',
					value: '下拉选择框',
					type: 'input',
					attrName: 'formTitle'
				}, {
					title: '默认值',
					value: null,
					type: 'input',
					attrName: 'defaultValue'
				}, {
					title: '宽度',
					value: '',
					type: 'input',
					attrName: 'width'
				}, {
					title: '占位内容',
					value: '',
					type: 'input',
					attrName: 'placeholder'
				}, {
					title: '是否多选',
					value: false,
					type: 'switch',
					attrName: 'multiple'
				}, {
					title: '是否可搜索',
					value: false,
					type: 'switch',
					attrName: 'filterable'
				}, {
					title: '是否显示标签',
					value: false,
					type: 'switch',
					attrName: 'showLabel'
				}, {
					value: false,
					type: 'switch',
					title: '隐藏',
					attrName: 'hide'
				},{
					title: '选项',
					list: [{
						title: '静态数据',
						value: false,
						type: 'radioButton',
						attrName: 'remote'
					}]
				}, {
					title: '操作属性',
					attrName: 'attr',
					list: [{
						value: false,
						type: 'checkbox',
						name: '禁用',
						attrName: 'disabled'
					}, {
						value: false,
						type: 'checkbox',
						name: '显示清除按钮',
						attrName: 'clearable'
					}]
				}, {
					title: '校验',
					attrName: 'regex',
					list: [{
						value: false,
						type: 'checkbox',
						name: '必填',
						attrName: 'required'
					},{
						value: '',
						type: 'input',
						placeholder: '错误信息提示',
						attrName: 'errormsg'
					}]
				}, {
					title: '选项',
					attrName: 'dynamicChange',
					list: [{
						value: false,
						type: 'radioButton',
						attrName: 'remote',
						remoteFunc: 'func_test',
						funcContent:'',
						method:'',
						data:'',
						Value:'',
						Label:'',
						props: {
							value: 'value',
							label: 'label'
						},
						options: [{
								label: '下拉框1',
								value: '下拉框1'
							},
							{
								label: '下拉框2',
								value: '下拉框2'
							},
							{
								label: '下拉框3',
								value: '下拉框3'
							}
						]
					}]
				},{
					value: [],
					attrName: 'remoteOptions'
				}
			]
		},
		{
			type: 'switch',
			name: '开关',
			icon: 'icon-switch',
			options: [{
				title: '标题',
				value: '开关',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '默认值',
				value: false,
				type: 'switch',
				attrName: 'defaultValue'
			}, {
				title: '开启默认值',
				value: 1,
				type: 'input',
				attrName: 'activeValue'
			},{
				title: '关闭默认值',
				value: 0,
				type: 'input',
				attrName: 'InActiveValue'
			},{
				title: '校验',
				attrName: 'regex',
				list: [{
					value: false,
					type: 'checkbox',
					name: '必填',
					attrName: 'required'
				},{
					value: '',
					type: 'input',
					placeholder: '错误信息提示',
					attrName: 'errormsg'
				}]
			}, {
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}]
		},
		{
			type: 'slider',
			name: '滑块',
			icon: 'icon-slider',
			options: [{
					title: '标题',
					value: '滑块',
					type: 'input',
					attrName: 'formTitle'
				}, {
					title: '默认值',
					value: 0,
					type: 'input',
					attrName: 'defaultValue'
				}, {
					title: '宽度',
					value: '100%',
					type: 'input',
					attrName: 'width'
				}, {
					title: '显示输入框',
					value: false,
					type: 'switch',
					attrName: 'showInput'
				}, {
					title: '最小值',
					value: 0,
					type: 'inputNumber',
					attrName: 'min'
				}, {
					title: '最大值',
					value: 100,
					type: 'inputNumber',
					attrName: 'max'
				}, {
					title: '步长',
					value: 1,
					type: 'inputNumber',
					attrName: 'step'
				}, {
					title: '操作属性',
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					title: '校验',
					attrName: 'regex',
					list: [{
						value: false,
						type: 'checkbox',
						name: '必填',
						attrName: 'required'
					},{
						value: '',
						type: 'input',
						placeholder: '错误信息提示',
						attrName: 'errormsg'
					}]
				}
				//    range: false,
			]
		}, {
			type: 'text',
			name: '文字',
			icon: 'icon-wenzishezhi-',
			options: [{
				title: '标题',
				value: '文字',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '默认值',
				value: '这是一段文本',
				type: 'input',
				attrName: 'defaultValue'
			}]
		}
	]
}, {
	label: '高级字段',
	value: [{
			type: 'blank',
			name: '自定义',
			icon: 'icon-zidingyishuju',
			options: [{
				title: '标题',
				value: '自定义',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '绑定数据类型',
				value: 'String',
				type: 'select',
				child: [{
						label: '字符',
						value: 'String'
					},
					{
						label: '对象',
						value: 'Object'
					},
					{
						label: '数组',
						value: 'Array'
					}
				],
				attrName: 'defaultType'
			}]
		},
		{
			type: 'upload',
			name: '文件',
			icon: 'icon-wenjianshangchuan',
			options: [{
					title: '标题',
					value: '文件',
					type: 'input',
					attrName: 'formTitle'
				}, {
					title: '宽度',
					value: '',
					type: 'input',
					attrName: 'width'
				}, {
					title: '最大上传数',
					value: 8,
					type: 'input',
					attrName: 'length'
				}, {
					title: '文件上传地址',
					value: 'https://jsonplaceholder.typicode.com/posts/',
					type: 'input',
					attrName: 'action'
				}, {
					title: '文件列表的类型',
					value: 'picture',
					type: 'input',
					attrName: 'listtype'
				},{
					title: '接受上传的文件类型',
					value: '.doc',
					type: 'input',
					attrName: 'accept'
				},{
					title: '按钮文本',
					value: '点击上传',
					type: 'input',
					attrName: 'btnname'
				},{
					title: '操作属性',
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					title: '默认值',
					value: '',
					type: 'input',
					attrName: 'defaultValue'
				}, {
					title: '是否多选',
					value: false,
					type: 'switch',
					attrName: 'multiple'
				},{
					title: '是否显示已上传文件列表',
					value: false,
					type: 'switch',
					attrName: 'showFile'
				}, {
					value: '',
					attrName: 'token'
				}
			]
		},
		{
			type: 'imgupload',
			name: '图片',
			icon: 'icon-tupian',
			options: [{
				title: '标题',
				value: '文件',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '类名',
				value: '',
				type: 'input',
				attrName: 'class'
			}, {
				title: '最大上传数',
				value: 8,
				type: 'input',
				attrName: 'length'
			}, {
				title: '文件上传地址',
				value: 'https://jsonplaceholder.typicode.com/posts/',
				type: 'input',
				attrName: 'action'
			}, {
				title: '文件列表的类型',
				value: 'picture',
				type: 'input',
				attrName: 'listtype'
			},{
				title: '接受上传的文件类型',
				value: '.doc',
				type: 'input',
				attrName: 'accept'
			},{
				title: '操作属性',
				value: false,
				type: 'checkbox',
				name: '禁用',
				attrName: 'disabled'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '是否多选',
				value: false,
				type: 'switch',
				attrName: 'multiple'
			},{
				title: '是否显示已上传文件列表',
				value: false,
				type: 'switch',
				attrName: 'showFile'
			},{
				title: '图片modelCode',
				value: '',
				attrName: 'modelCode'
			}, {
				value: '',
				attrName: 'token'
			}
		]
		},
		// {
		// 	type: 'imgupload',
		// 	name: '图片',
		// 	icon: 'icon-tupian',
		// 	options: [{
		// 			title: '标题',
		// 			value: '文件',
		// 			type: 'input',
		// 			attrName: 'formTitle'
		// 		}, {
		// 			title: '宽度',
		// 			value: 100,
		// 			type: 'input',
		// 			attrName: 'width'
		// 		}, {
		// 			value: [],
		// 			attrName: 'defaultValue'
		// 		}, {
		// 			title: '最小值',
		// 			value: 0,
		// 			type: 'inputNumber',
		// 			attrName: 'min'
		// 		}, {
		// 			title: '是否多选',
		// 			value: false,
		// 			type: 'switch',
		// 			attrName: 'multiple'
		// 		}, {
		// 			title: '最大上传数',
		// 			value: 8,
		// 			type: 'input',
		// 			attrName: 'length'
		// 		}, {
		// 			title: '图片上传地址',
		// 			value: 'https://jsonplaceholder.typicode.com/posts/',
		// 			type: 'input',
		// 			attrName: 'action'
		// 		}, {
		// 			title: '操作属性',
		// 			attrName: 'attr',
		// 			list: [{
		// 				value: false,
		// 				type: 'checkbox',
		// 				name: '禁用',
		// 				attrName: 'disabled'
		// 			}, {
		// 				value: false,
		// 				type: 'checkbox',
		// 				name: '删除',
		// 				attrName: 'isDelete'
		// 			}, {
		// 				value: false,
		// 				type: 'checkbox',
		// 				name: '编辑',
		// 				attrName: 'isEdit'
		// 			}]
		// 		}, {
		// 			value: '',
		// 			attrName: 'token'
		// 		}, {
		// 			value: 'http://pfp81ptt6.bkt.clouddn.com/',
		// 			attrName: 'domain'
		// 		}, {
		// 			value: false,
		// 			attrName: 'isQiniu'
		// 		}, {
		// 			value: 'funcGetToken',
		// 			attrName: 'tokenFunc'
		// 		}
		// 	]
		// }
		{
			type: 'editor',
			name: '编辑器',
			icon: 'icon-fuwenbenkuang',
			options: [{
				title: '标题',
				value: '编辑器',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '宽度',
				value: '',
				type: 'input',
				attrName: 'width'
			}]
		},
		{
			type: 'cascader',
			name: '级联选择器',
			icon: 'icon-jilianxuanze',
			options: [{
				title: '标题',
				value: '级联选择器',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '默认值',
				value: '',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '宽度',
				value: '',
				type: 'input',
				attrName: 'width'
			}, {
				title: '占位内容',
				value: '',
				type: 'input',
				attrName: 'placeholder'
			}, {
				title: '操作属性',
				attrName: 'attr',
				list: [{
					value: false,
					type: 'checkbox',
					name: '禁用',
					attrName: 'disabled'
				}, {
					value: false,
					type: 'checkbox',
					name: '显示清除按钮',
					attrName: 'clearable'
				}]
			}, {
				title: '远端数据',
				attrName: 'dynamicChange',
				list: [{
					value: true,
					attrName: 'remote',
					remoteFunc: '',
					props: {
						value: 'value',
						label: 'label',
						children: 'children'
					}
				}]
			}, {
				value: [],
				attrName: 'remoteOptions'
			}]
		}
	]
}, {
	label: '布局字段',
	value: [{
			type: 'grid',
			name: '栅格布局',
			icon: 'icon-grid-',
			options: [{
				title: '栅格间隔',
				value: 0,
				type: 'input',
				attrName: 'gutter'
			}, {
				title: '水平排列方式',
				value: 'start',
				type: 'select',
				attrName: 'justify',
				child: [{
					label: '左对齐',
					value: 'start'
				}, {
					label: '右对齐',
					value: 'end'
				}, {
					label: '居中',
					value: 'center'
				}, {
					label: '两侧间隔相等',
					value: 'space-around'
				}, {
					label: '两端对齐',
					value: 'space-between'
				}]
			}, {
				title: '垂直排列方式',
				value: 'top',
				type: 'select',
				attrName: 'align',
				child: [{
					label: '顶部对齐',
					value: 'start'
				}, {
					label: '居中',
					value: 'middle'
				}, {
					label: '底部对齐',
					value: 'bottom'
				}]
			}, {
				title: '列配置项',
				value: '',
				type: 'input',
				attrName: 'grid',
				group: [{
					span: 12,
					list: []
				}, {
					span: 12,
					list: []
				}]
			}]
		},
		{
			type: 'tabs',
			name: '标签页',
			icon: 'icon-tabs',
			options: [{
				title: '标题',
				value: '标签页',
				type: 'input',
				attrName: 'formTitle'
			}, {
				value: 'first',
				attrName: 'defaultValue'
			}, {
				title: '风格类型',
				value: '',
				type: 'radioButton',
				attrName: 'types',
				groups: [{
					label: '默认',
					value: ''
				}, {
					label: '选项卡',
					value: 'card'
				}, {
					label: '卡片化',
					value: 'border-card'
				}]
			}, {
				title: '选项卡位置',
				value: 'top',
				type: 'radioButton',
				attrName: 'tabPosition',
				groups: [{
					label: '顶部',
					value: 'top'
				}, {
					label: '左侧',
					value: 'left'
				}, {
					label: '右侧',
					value: 'right'
				}, {
					label: '底部',
					value: 'bottom'
				}]
			}, {
				title: '标签配置项',
				value: '',
				type: 'input',
				attrName: 'tabChange',
				group: [{
					label: 'Tab1',
					name: 'first',
					list: []
				}]
			}]
		}, {
			type: 'divider',
			name: '分割线',
			icon: 'icon-fengexian',
			options: [{
				title: '标题',
				value: '分割线',
				type: 'input',
				attrName: 'formTitle'
			}, {
				title: '分割线文案',
				value: '分割线',
				type: 'input',
				attrName: 'defaultValue'
			}, {
				title: '文案位置',
				value: 'left',
				type: 'radioButton',
				attrName: 'position',
				groups: [{
					label: '左侧',
					value: 'left'
				}, {
					label: '右侧',
					value: 'right'
				}, {
					label: '居中',
					value: 'center'
				}]
			}, {
				title: '分割方向',
				value: 'horizontal',
				type: 'radioButton',
				attrName: 'direction',
				groups: [{
					label: '默认',
					value: 'horizontal'
				}, {
					label: '垂直',
					value: 'vertical'
				}]
			}]
		}
	]
}]


// WEBPACK FOOTER //
// ./src/components/vueformmaking/componentsConfig.js